var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStack2Brb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3521_53967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.6522 96.1522H96.1522V95.6522V30.4348V29.9348H95.6522H4.34785H3.84785V30.4348V95.6522V96.1522H4.34785H95.6522ZM2.17383 26.5869H97.8262C98.75 26.5869 99.5 27.337 99.5 28.2609V97.8262C99.5 98.75 98.75 99.5 97.8262 99.5H2.17383C1.24997 99.5 0.5 98.75 0.5 97.8262V28.2607C0.5 27.3369 1.24997 26.5869 2.17383 26.5869Z",
    fill: "#6172F3",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0434 16.8913H12.5434V17.3913V19.5651C12.5434 20.489 11.7934 21.239 10.8695 21.239C9.94568 21.239 9.19571 20.489 9.19571 19.5651V15.2173C9.19571 14.2934 9.94568 13.5435 10.8695 13.5435H89.1305C90.0543 13.5435 90.8043 14.2934 90.8041 15.2172V19.5651C90.8041 20.489 90.0541 21.239 89.1303 21.239C88.2064 21.239 87.4565 20.489 87.4565 19.5651V17.3913V16.8913H86.9565H13.0434Z",
    fill: "#A4BCFD",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7391 3.84785H21.2391V4.34785V6.52168C21.2391 7.44554 20.4891 8.19551 19.5652 8.19551C18.6414 8.19551 17.8914 7.44554 17.8914 6.52168V2.17383C17.8914 1.24997 18.6414 0.5 19.5652 0.5H80.4348C81.3587 0.5 82.1087 1.25002 82.1084 2.17367V2.17383V6.52168C82.1084 7.44554 81.3584 8.19551 80.4346 8.19551C79.5107 8.19551 78.7608 7.44554 78.7608 6.52168V4.34785V3.84785H78.2608H21.7391Z",
    fill: "#C7D7FE",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 30,
    width: 92,
    height: 66,
    fill: "#F5F8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3521_53967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack2Brb);
export default __webpack_public_path__ + "static/media/stack 2_brb.c5d4292c6d98ad87be3333448a1a7de9.svg";
export { ForwardRef as ReactComponent };